import React, { useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material'

const PortalChatDialog = ({
  open,
  request,
  currentRole,
  title = 'Control room chat',
  onClose,
  onSend,
}) => {
  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)

  const sendMessage = async () => {
    const trimmedMessage = message.trim()
    if (!trimmedMessage || sending) return

    setSending(true)
    const sent = await onSend?.(trimmedMessage)
    if (sent) setMessage('')
    setSending(false)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack gap={1.5} sx={{ pt: 1 }}>
          <Box
            sx={{
              minHeight: 260,
              maxHeight: 360,
              overflowY: 'auto',
              bgcolor: '#F8FAFC',
              border: '1px solid #E2E8F0',
              borderRadius: 2,
              p: 1.5,
            }}
          >
            <Stack gap={1}>
              {(request?.messages || []).length ? (
                request.messages.map((chatMessage) => {
                  const mine = chatMessage.senderRole === currentRole

                  return (
                    <Box
                      key={chatMessage._id}
                      sx={{
                        alignSelf: mine ? 'flex-end' : 'flex-start',
                        maxWidth: '78%',
                        bgcolor: mine ? '#0F766E' : '#FFFFFF',
                        color: mine ? '#FFFFFF' : '#0F172A',
                        border: mine ? 'none' : '1px solid #E2E8F0',
                        borderRadius: 2,
                        px: 1.25,
                        py: 1,
                      }}
                    >
                      <Typography sx={{ fontSize: '0.8rem', fontWeight: 900 }}>
                        {mine
                          ? 'You'
                          : chatMessage.author?.name ||
                            chatMessage.senderRole}
                      </Typography>
                      <Typography variant="body2">
                        {chatMessage.message}
                      </Typography>
                    </Box>
                  )
                })
              ) : (
                <Typography color="text.secondary" variant="body2">
                  No messages yet.
                </Typography>
              )}
            </Stack>
          </Box>
          <TextField
            label="Message"
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                sendMessage()
              }
            }}
            multiline
            minRows={2}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          variant="contained"
          onClick={sendMessage}
          disabled={!message.trim() || sending}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PortalChatDialog
